<template>
    <div class="h-full">
        <div
            class="mt-4 h-full rounded-lg border border-stone-300 bg-white px-10 py-5 shadow-sm"
        >
            <p class="text-lg font-semibold tracking-tight">
                {{ $t("team_reports.recent.title") }}
            </p>

            <Tabs class="mt-4" default-value="upcoming">
                <TabsList>
                    <TabsTrigger value="upcoming">
                        {{ $t("team_reports.recent.upcomming") }}
                    </TabsTrigger>
                    <TabsTrigger value="booked">
                        {{ $t("team_reports.recent.recently_booked") }}
                    </TabsTrigger>
                    <TabsTrigger value="canceled">
                        {{ $t("team_reports.recent.recently_canceled") }}
                    </TabsTrigger>
                </TabsList>
                <TabsContent v-auto-animate class="pt-2" value="upcoming">
                    <div
                        v-if="upcomingReservations.total === 0"
                        class="mt-10 flex justify-center text-sm"
                    >
                        <p>{{ $t("team_reports.recent.no_upcoming") }}</p>
                    </div>
                    <ScrollArea class="h-[450px]">
                        <div
                            v-for="(
                                reservation, i
                            ) in upcomingReservations.data"
                            :key="i"
                            class="my-4 flex items-center gap-2"
                        >
                            <TooltipProvider>
                                <Tooltip>
                                    <TooltipTrigger>
                                        <img
                                            class="h-8 w-8 rounded-full"
                                            :src="
                                                getUserById(reservation.user_id)
                                                    ?.profile_photo_url
                                            "
                                            alt=""
                                        />
                                    </TooltipTrigger>
                                    <TooltipContent>
                                        <p>
                                            {{
                                                getUserById(reservation.user_id)
                                                    ?.name
                                            }}
                                        </p>
                                    </TooltipContent>
                                </Tooltip>
                            </TooltipProvider>

                            <ArrowRight class="mt-0 text-iron-900" :size="18" />
                            <div>
                                <p class="text-sm font-medium text-iron-900">
                                    {{
                                        reservation.firstname +
                                        " " +
                                        reservation.lastname
                                    }}
                                </p>
                                <p class="text-sm text-iron-800">
                                    {{ reservation.email }}
                                </p>

                                <div class="mt-1 flex items-center gap-2">
                                    <div
                                        class="h-4 w-4"
                                        v-html="
                                            getLocationForId(
                                                reservation.location.type,
                                            )?.icon
                                        "
                                    ></div>
                                    <p class="text-sm text-iron-600">
                                        {{
                                            format(
                                                new Date(reservation.start),
                                                "d. M. H:mm",
                                            )
                                        }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </ScrollArea>
                </TabsContent>
                <TabsContent v-auto-animate class="pt-2" value="booked">
                    <div
                        v-if="recentlyBookedReservations.total === 0"
                        class="mt-10 flex justify-center text-sm"
                    >
                        <p>
                            {{ $t("team_reports.recent.no_recently_booked") }}
                        </p>
                    </div>

                    <ScrollArea class="h-[450px]">
                        <div
                            v-for="(
                                reservation, i
                            ) in recentlyBookedReservations.data"
                            :key="i"
                            class="my-4 flex items-center gap-3"
                        >
                            <TooltipProvider>
                                <Tooltip>
                                    <TooltipTrigger>
                                        <img
                                            class="h-8 w-8 rounded-full"
                                            :src="
                                                getUserById(reservation.user_id)
                                                    ?.profile_photo_url
                                            "
                                            alt=""
                                        />
                                    </TooltipTrigger>
                                    <TooltipContent>
                                        <p>
                                            {{
                                                getUserById(reservation.user_id)
                                                    ?.name
                                            }}
                                        </p>
                                    </TooltipContent>
                                </Tooltip>
                            </TooltipProvider>

                            <div class="flex w-[70px] flex-col items-center">
                                <ArrowRight
                                    class="mt-0 text-iron-900"
                                    :size="20"
                                />
                                <div
                                    class="mt-1 flex items-center gap-2 text-sm text-iron-600"
                                >
                                    <p>
                                        {{
                                            format(
                                                new Date(
                                                    reservation.created_at,
                                                ),
                                                "d. M. H:mm",
                                            )
                                        }}
                                    </p>
                                </div>
                            </div>
                            <div>
                                <p class="text-sm font-medium text-iron-900">
                                    {{
                                        reservation.firstname +
                                        " " +
                                        reservation.lastname
                                    }}
                                </p>
                                <p class="text-sm text-iron-800">
                                    {{ reservation.email }}
                                </p>

                                <div class="mt-1 flex items-center gap-2">
                                    <div
                                        class="h-4 w-4"
                                        v-html="
                                            getLocationForId(
                                                reservation.location.type,
                                            )?.icon
                                        "
                                    ></div>
                                    <p class="text-sm text-iron-600">
                                        {{
                                            format(
                                                new Date(reservation.start),
                                                "d. M. H:mm",
                                            )
                                        }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </ScrollArea>
                </TabsContent>
                <TabsContent v-auto-animate class="pt-2" value="canceled">
                    <div
                        v-if="canceledReservations.total === 0"
                        class="mt-10 flex justify-center text-sm"
                    >
                        <p>
                            {{ $t("team_reports.recent.no_recently_canceled") }}
                        </p>
                    </div>

                    <ScrollArea class="h-[450px]">
                        <div
                            v-for="(
                                reservation, i
                            ) in canceledReservations.data"
                            :key="i"
                            class="my-4 flex items-center gap-3"
                        >
                            <TooltipProvider>
                                <Tooltip>
                                    <TooltipTrigger>
                                        <img
                                            class="h-8 w-8 rounded-full"
                                            :src="
                                                getUserById(reservation.user_id)
                                                    ?.profile_photo_url
                                            "
                                            alt=""
                                        />
                                    </TooltipTrigger>
                                    <TooltipContent>
                                        <p>
                                            {{
                                                getUserById(reservation.user_id)
                                                    ?.name
                                            }}
                                        </p>
                                    </TooltipContent>
                                </Tooltip>
                            </TooltipProvider>

                            <div class="flex flex-col items-center">
                                <X class="mt-0 text-iron-900" :size="18" />
                                <p
                                    class="mt-1 flex items-center gap-2 text-sm text-iron-600"
                                >
                                    {{
                                        format(
                                            new Date(reservation.updated_at),
                                            "d. M. H:mm",
                                        )
                                    }}
                                </p>
                            </div>
                            <div>
                                <p class="text-sm font-medium text-iron-900">
                                    {{
                                        reservation.firstname +
                                        " " +
                                        reservation.lastname
                                    }}
                                </p>
                                <p class="text-sm text-iron-800">
                                    {{ reservation.email }}
                                </p>
                            </div>
                        </div>
                    </ScrollArea>
                </TabsContent>
            </Tabs>
        </div>
    </div>
</template>

<script setup lang="ts">
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { CalendarPlus, ArrowRight, CalendarX2, X } from "lucide-vue-next";
import { PaginatedData } from "@/types/Pagination";
import { Reservation } from "../../Dashboard/components/event.vue";
import { vAutoAnimate } from "@formkit/auto-animate";
import { User } from "../../EventTypes/types/EventType";
import { useLocalisedTzFormat } from "@/composables/useLocalisedTzFormat";
import { useLocationOptions } from "../../EventTypes/useLocationOptions";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "@/components/ui/tooltip";

import { ScrollArea } from "@/components/ui/scroll-area";

const { getLocationForId } = useLocationOptions();

const { format } = useLocalisedTzFormat();

const props = defineProps<{
    upcomingReservations: PaginatedData<Reservation>;
    canceledReservations: PaginatedData<Reservation>;
    recentlyBookedReservations: PaginatedData<Reservation>;
    selectedUser?: User;
    teamMembers: User[];
}>();

function getUserById(userId: number) {
    return props.teamMembers.find((user) => user.id === userId);
}
</script>
